<template>
    <div v-show="isVisible" :class="{

        'col-lg-12': true
   
       

    }" >


        <hr class="d-none d-md-flex" />


        <h3 style="padding: 1rem .5rem;"> {{title}} </h3>


    </div>
</template>

<script>


    import { bus } from '../main';
   

    export default {
        name: "BlockTitle",


        data(){
            return {

                isVisible: !this.element.hidden

            }
        },


        props: {
            element: {
                type: Object,
                required: true
            },

            name: {
                type: String,
                required: true
            }                  
            
        },

      

        methods: {



         
        },

        computed: {


            title(){

                return this.element.title;
            }

        },



        created() {

            bus.$on('visibility', (bind, checked ) => {

                bind.split(',').indexOf(this.name) > -1 
                    && (this.isVisible = checked);
            });

           // console.log(this.element);


           // console.log('created renderer')
/*setTimeout(() => {


 this.$parent.$set(this.$parent.form, 'test', 'none')

      }, 3000)*/

          
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/BlockTitle.vue